var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTelegram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 29 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.315 9.712c-2.9 1.133-.733 2.28-.733 2.28l6.306 2.275 3.589 1.546 3.739 3.166s3.482 2.48 5.86 4.363c2.084 1.437 2.677-.694 2.677-.694S27.423 4.2 27.92 1.773c.694-2.28-1.752-1.335-1.752-1.335C16.192 3.597 2.315 9.713 2.315 9.713z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CAE0EE",
  d: "M23.115 5.307c.931-1.144-.345-.638-.345-.638L7.89 14.267s1.537 4.86 2.182 7.09c.496 2.083 1.687.992 1.687.992l3.459-3.373-3.74-3.166S22.557 5.781 23.117 5.304z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#9ABDDB",
  d: "m11.477 15.813 3.739 3.166-3.46 3.373s-.427.392-.878.258c-.3-.09.597-6.796.597-6.796"
})));
export default SvgTelegram;